import { GetServerSideProps, NextPage } from 'next';
import { NextSeo } from 'next-seo';
import { Fragment, useEffect } from 'react';

import { Container } from '@/components/core/Grid';
import { Layout } from '@/components/ui/shared/layouts/Layout/Layout';
import { SignUpFlow } from '@/containers/SignUp/SignUpFlow';
import { useAnalytics } from '@/context/Analytics';
import { AccessFrom } from '@/enums/AccessFrom';
import { StringParam, useQueryParams } from '@/hooks/useQueryParams';

const CreateAccount: NextPage = () => {
  const { accessFrom = AccessFrom.Core } = useQueryParams<{ accessFrom: AccessFrom }>({
    accessFrom: StringParam,
  });

  const analytics = useAnalytics();

  useEffect(() => {
    analytics.track('user_login_open');
  }, [analytics]);

  return (
    <Fragment>
      <NextSeo
        title="Create Account"
        openGraph={{
          url: `${process.env.NEXT_PUBLIC_BASE_URL}/create-account`,
        }}
      />
      <Layout accessFrom={accessFrom} navigationVariant="inverted" displayFooter={false}>
        <Container>
          <SignUpFlow />
        </Container>
      </Layout>
    </Fragment>
  );
};

// keep this pages SSR because we need a query params on initial render
export const getServerSideProps: GetServerSideProps = async () => {
  return {
    props: {},
  };
};

export default CreateAccount;
